import styled from 'styled-components'

export const NoCompareValue = styled.div`
  padding: 9px 10px 10px 20px;
  width: auto;
  //height: 100%;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  > p {
    vertical-align: center;
    padding-top: 10px;
    margin: 0;
  }
`
